import { useEffect, useRef } from 'react';

import { useAppDispatch, useAppSelector } from '@/hooks/redux-hooks';
import { useTripTokenFromStorage } from '@/services/storage';
import { getUserConfig } from '@/slices/userConfigSlice';

const useUserDateFormat = () => {
  const dispatch = useAppDispatch();
  const dispatchFlag = useRef(false);
  const { userConfig, status } = useAppSelector(state => state.userConfig);

  const tripToken = useTripTokenFromStorage();

  useEffect(() => {
    if (status === 'fulfilled' || dispatchFlag.current || !tripToken) return;
    dispatch(getUserConfig());
    dispatchFlag.current = true;
  }, [status, tripToken]);

  return userConfig.dateFormat;
};

export default useUserDateFormat;
